// @flow

import { WelcomeMessage } from '../models'

import { CHAT_BUBBLE_HEIGHT, CHAT_BUBBLE_WIDTH } from '../../common/size'
import { FULL_SIZE } from '../../main/iframe/fullSize'

type Rect = {
  width: number,
  height: number
}

const WELCOME_TEXT_WRAPPER_PADDING_PLUS_BORDER = 32

export function heightForWelcomeMessage (welcomeMessage: WelcomeMessage): number {
  const textHeight = Math.round(welcomeMessage.description.length / 30 + 1) * 30
  return Math.max(textHeight + WELCOME_TEXT_WRAPPER_PADDING_PLUS_BORDER, CHAT_BUBBLE_HEIGHT)
}

export default {
  methods: {
    getIframeSize (): Rect {
      if (!this.bubble) {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        }
      }
      if (this.isShowingOpenChat && this.bubble.isOpen) {
        return {
          width: FULL_SIZE,
          height: 450
        }
      } else if (this.bubble.isOpen) {
        return {
          width: FULL_SIZE,
          height: FULL_SIZE
        }
      } else if (this.isShowingWelcomeMessage) {
        return {
          width: FULL_SIZE,
          height: heightForWelcomeMessage(this.welcomeMessage.welcomeMessage)
        }
      } else {
        return {
          width: CHAT_BUBBLE_WIDTH,
          height: CHAT_BUBBLE_HEIGHT
        }
      }
    }
  }
}
